/**
 * Registers all tool components the Analysis Agent can emit. Render once
 * inside an `AssistantRuntimeProvider` so the runtime knows how to render
 * each tool-call part type.
 */
import type { FC } from "react";
import {
  ApprovalCardTool,
  AskUserQuestionTool,
  PipelineCancellationTool,
  PipelineConfirmationTool,
} from "~/components/assistant-v2/tools";

interface AnalysisAgentToolsProps {
  pipelineToolsEnabled?: boolean;
}

export const AnalysisAgentTools: FC<AnalysisAgentToolsProps> = ({ pipelineToolsEnabled }) => (
  <>
    <AskUserQuestionTool />
    <ApprovalCardTool />
    {pipelineToolsEnabled && <PipelineConfirmationTool />}
    {pipelineToolsEnabled && <PipelineCancellationTool />}
  </>
);
